import React, { useCallback, useContext, useEffect, useMemo, useState } from 'react';
import _ from 'lodash';

import {
  CircularProgress,
  FormControl,
  FormHelperText,
  Grid,
  InputLabel,
  Select,
  TextField,
} from '@material-ui/core';
import vehiclesEndpoint from 'app/api/services/vehiclesEndpoint';
import { LICENSE_CHAGES_TYPE } from 'app/config/services';
import { FormServiceContext } from 'app/utils/contexts';
import { Field } from 'formik';
import { useSelector } from 'react-redux';
import InfoRequest from '../ServicesForms/Licenses/LicenseDuplicateRegistration/components/Request/InfoRequest';
import { STATUS_CODES } from 'app/config/status';

const withLicenseDuplicateVehicle = BaseComponent => props => {
  const { errors, values, selectedChangeType, oldLicense, setFieldValue } = props;

  const { canEdit, isInternalForm } = useContext(FormServiceContext);

  const [loading, setLoading] = useState(false);
  const [cdVeiculoOrigem, setCdVeiculoOrigem] = useState();
  const [vehicleIndex, setVehicleIndex] = useState(0);

  const cities = useSelector(state => state.forms.cities);
  const vehicleType = useSelector(state => state.vehicle.vehicleType);
  const vehicleCategories = useSelector(state => state.vehicle.vehicleCategories);
  const documentsStoreVehicle = useSelector(state => state.vehicle.licenseVehicleDocuments);

  const request = useSelector(state => state.requests.details);
  const requestJsonData = useMemo(() => {
    return request.jsonSolicitacao ? JSON.parse(request.jsonSolicitacao) : {};
  }, [request]);

  const inspectedVehicles = useSelector(state => state.vehicle.inspectedVehicles);
  const [inspectedVehiclesFiltered, setInspectedVehiclesFiltered] = useState(() => {
    if (
      (!request.cdSituacao || request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO) &&
      inspectedVehicles
    ) {
      return inspectedVehicles;
    }
    return [];
  });

  const [oldVehicle, setOldVehicle] = useState({});
  const [newVehicle, setNewVehicle] = useState({});

  const [vehicles, setVehicles] = useState([]);

  const handleChangeOldVehicle = useCallback(
    async (value, originalVehicleObj) => {
      if (value) {
        const found = _.find(vehicles, o => {
          return o.cdVeiculo === value || o.cdVeiculo === Number(value);
        });
        if (found && found.veiculo) {
          const documentsVehiclesTypes = documentsStoreVehicle.map(d => d.cdTipoDocumento);
          const temp = {
            cdVeiculo: Number(value),
            name: found.veiculo.nmProprietario,
            document: found.veiculo.deCpfCnpjProprietario,
            capacity: found.veiculo.qtCapacidade,
          };
          const city = cities.filter(o => o.cdMunicipio === found.veiculo.cdMunicipio);
          const type = vehicleType.filter(o => o.cdTipoVeiculo === found.veiculo.cdTipoVeiculo);
          const category = vehicleCategories.filter(
            o => o.cdCategoriaVeiculo === found.veiculo.cdCategoriaVeiculo
          );
          temp.city = city[0]?.nmMunicipio || '';
          temp.type = type[0]?.deTipoVeiculo || '';
          temp.category = category[0]?.deCategoriaVeiculo || '';

          //CHANGING CITY OR OWNER
          if (Number(selectedChangeType) !== LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO) {
            setNewVehicle({});
            const response = await vehiclesEndpoint.getVehicle(found.cdVeiculo);
            if (response?.status === 200 && response?.data) {
              const veiculoReq = response.data;

              let tempDocuments =
                veiculoReq.documentos.filter(doc => {
                  return documentsVehiclesTypes.includes(doc.cdTipoDocumento);
                }) || [];

              if (originalVehicleObj?.documentos) {
                const isSameVehicle = originalVehicleObj?.documentos.filter(
                  d => Number(d.cdVeiculo) === Number(found.cdVeiculo)
                );
                if (isSameVehicle.length > 0) {
                  tempDocuments = originalVehicleObj?.documentos;
                }
              }

              found.veiculo.documentos = [];
              tempDocuments.forEach(doc => {
                const tempCdTipoDocumentos = found.veiculo.documentos.map(d => d.cdTipoDocumento);
                if (!tempCdTipoDocumentos.includes(doc.cdTipoDocumento)) {
                  found.veiculo.documentos.push(doc);
                }
              });

              const tempNew = {
                cdVeiculo: Number(value),
                name: veiculoReq.nmProprietario,
                plate: veiculoReq.dePlaca,
                document: veiculoReq.deCpfCnpjProprietario,
                capacity: veiculoReq.qtCapacidade,
              };
              const city = cities.filter(o => o.cdMunicipio === veiculoReq.cdMunicipio);
              const type = vehicleType.filter(o => o.cdTipoVeiculo === veiculoReq.cdTipoVeiculo);
              const category = vehicleCategories.filter(
                o => o.cdCategoriaVeiculo === veiculoReq.cdCategoriaVeiculo
              );
              tempNew.city = city[0]?.nmMunicipio || '';
              tempNew.type = type[0]?.deTipoVeiculo || '';
              tempNew.category = category[0]?.deCategoriaVeiculo || '';

              setNewVehicle(tempNew);
            }
          }

          setFieldValue(`licencaVeiculos[${vehicleIndex}].veiculo`, found.veiculo);
          setOldVehicle(temp);
          setCdVeiculoOrigem(value);
        }
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cities, vehicleCategories, selectedChangeType, vehicleType, vehicles, documentsStoreVehicle]
  );

  const handleChangeNewVehicle = useCallback(
    (value, index, veiculoSubstituirObj) => {
      let temp = {};
      if (value) {
        let found = null;
        if (
          (!request.cdSituacao
            || request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO
            || request.cdSituacao === STATUS_CODES.AGUARDANDO_RESOLUCAO_PENDENCIAS
          ) &&
          !isInternalForm
        ) {
          const documentsVehiclesTypes = documentsStoreVehicle.map(d => d.cdTipoDocumento);
          found = _.find(inspectedVehicles, o => {
            return o.cdVeiculo === value || o.cdVeiculo === Number(value);
          });

          if (found) {
            found = { ...found, documentos: [] };
          } else if (!found && veiculoSubstituirObj) {
            found = { ...veiculoSubstituirObj, documentos: [] };
          } else {
            found = { documentos: [] };
          }

          let tempDocuments =
            found.documentos.filter(doc => {
              return documentsVehiclesTypes.includes(doc.cdTipoDocumento);
            }) || [];

          if (veiculoSubstituirObj?.documentos) {
            const isSameVehicle = veiculoSubstituirObj?.documentos.filter(
              d => Number(d.cdVeiculo) === Number(found.cdVeiculo)
            );
            if (isSameVehicle.length > 0) {
              tempDocuments = veiculoSubstituirObj?.documentos;
            }
          }

          tempDocuments.forEach(doc => {
            const tempCdTipoDocumentos = found.documentos.map(d => d.cdTipoDocumento);
            if (!tempCdTipoDocumentos.includes(doc.cdTipoDocumento)) {
              found.documentos.push(doc);
            }
          });
        } else {
          found = requestJsonData.licencaVeiculos[index].veiculoSubstituir;
          found = { ...found };
        }
        if (found) {
          temp = {
            cdVeiculo: Number(value),
            name: found.nmProprietario,
            document: found.deCpfCnpjProprietario,
            capacity: found.qtCapacidade,
          };
          const city = cities.filter(o => o.cdMunicipio === found.cdMunicipio);
          const type = vehicleType.filter(o => o.cdTipoVeiculo === found.cdTipoVeiculo);
          const category = vehicleCategories.filter(
            o => o.cdCategoriaVeiculo === found.cdCategoriaVeiculo
          );
          temp.city = city[0]?.nmMunicipio || '';
          temp.type = type[0]?.deTipoVeiculo || '';
          temp.category = category[0]?.deCategoriaVeiculo || '';
          setFieldValue(`licencaVeiculos[${index}].veiculoSubstituir`, found);
        }
      }
      setNewVehicle(temp);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [cities, inspectedVehicles, vehicleCategories, vehicleType, documentsStoreVehicle]
  );

  useEffect(() => {
    //SETTING FILTERED VEHICLE TO SELECT
    const init = () => {
      setLoading(true);
      if (!isInternalForm) {
        if (oldLicense?.licencaVeiculos) {
          const tempVehicles = oldLicense.licencaVeiculos;
          if (Number(selectedChangeType) === LICENSE_CHAGES_TYPE.SUBSTITUICAO_VEICULO) {
            let temp = inspectedVehicles;
            if (oldVehicle.cdVeiculo) {
              const plateAlreadyOnLicense = tempVehicles.map(vv => {
                return vv.veiculo?.dePlaca;
              });
              temp = inspectedVehicles.filter(
                v =>
                  v.cdVeiculo !== oldVehicle.cdVeiculo && !plateAlreadyOnLicense.includes(v.dePlaca)
              );
            }
            setInspectedVehiclesFiltered(temp);
          }
        }
      } else {
        //isInternalForm
        const found = requestJsonData.licencaVeiculos
          .filter(lv => lv.cdVeiculoSubstituir != null)
          .map(lv => {
            if (lv['veiculoSubstituir']) return lv['veiculoSubstituir'];
            return lv['veiculo'];
          });
        setInspectedVehiclesFiltered(found);
      }
      setLoading(false);
    };
    init();
  }, [
    inspectedVehicles,
    oldVehicle.cdVeiculo,
    selectedChangeType,
    oldLicense,
    isInternalForm,
    requestJsonData.licencaVeiculos,
    request.cdSituacao,
  ]);

  useEffect(() => {
    const init = () => {
      setLoading(true);
      if (oldLicense?.licencaVeiculos) {
        const tempVehicles = oldLicense.licencaVeiculos;
        setVehicles(tempVehicles);
      }
      setLoading(false);
    };
    init();
  }, [oldLicense]);

  useEffect(() => {
    const init = () => {
      if (vehicles.length > 0) {
        const vehicleList = requestJsonData.licencaVeiculos || values.licencaVeiculos || [];
        if (vehicleList) {
          let cdOriginalVehicle = null;
          let originalVehicle = null;
          let cdVeiculoSubstituir = null;
          let veiculoSubstituir = null;
          let vehiIndex = 0;
          //JUST ONE
          if (
            !request.cdSituacao ||
            request.cdSituacao === STATUS_CODES.EM_CONSTRUCAO ||
            vehicleList.length === 1
          ) {
            cdOriginalVehicle = vehicleList[vehiIndex]?.cdVeiculoAntigo
              ? vehicleList[vehiIndex]?.cdVeiculoAntigo
              : vehicleList[vehiIndex]?.cdVeiculo;
            originalVehicle = vehicleList[vehiIndex]?.veiculo;
            cdVeiculoSubstituir = vehicleList[vehiIndex]?.cdVeiculoSubstituir;
            veiculoSubstituir = vehicleList[vehiIndex]?.veiculoSubstituir;
          } else {
            vehicleList.forEach((lv, index) => {
              if (lv.cdVeiculoAntigo) {
                cdOriginalVehicle = lv.cdVeiculoAntigo;
                cdVeiculoSubstituir = lv.cdVeiculoSubstituir;
                originalVehicle = lv.veiculo;
                veiculoSubstituir = lv.veiculoSubstituir || {};
                vehiIndex = index;
              }
            });
          }

          setVehicleIndex(vehiIndex);
          handleChangeOldVehicle(cdOriginalVehicle, originalVehicle);
          if (cdVeiculoSubstituir && Object.keys(newVehicle).length === 0) {
            handleChangeNewVehicle(cdVeiculoSubstituir, vehiIndex, veiculoSubstituir);
          }
        }
      }
    };
    init();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    request.cdSituacao,
    requestJsonData.licencaVeiculos,
    // values.licencaVeiculos,
    vehicles.length,
  ]);

  if (loading) {
    return (
      <Grid item xs={12} style={{ textAlign: 'center' }}>
        <CircularProgress size={18} />
      </Grid>
    );
  }

  return (
    <>
      <InfoRequest {...props} />

      <Grid item xs={12} sm={6}>
        <FormControl
          variant="filled"
          margin="dense"
          disabled={isInternalForm || !canEdit}
          fullWidth
          error={errors.licencaVeiculos && !!errors.licencaVeiculos[vehicleIndex]?.cdVeiculo}
          onChange={e => handleChangeOldVehicle(e.target.value)}
        >
          <InputLabel shrink={true} htmlFor={`licencaVeiculos[${vehicleIndex}].cdVeiculo`}>
            Placa do veículo
          </InputLabel>
          <Field
            name={`licencaVeiculos[${vehicleIndex}].cdVeiculo`}
            id={`licencaVeiculos[${vehicleIndex}].cdVeiculo`}
            native
            as={Select}
            value={cdVeiculoOrigem}
            validate={value => {
              let error;
              if (!value) {
                error = 'Campo obrigatório';
              }
              return error;
            }}
          >
            <option aria-label="None" value="" />
            {vehicles.map((v, index) => {
              return (
                <option key={`cdVeiculo-${index}`} value={v.cdVeiculo}>
                  {v.veiculo?.dePlaca}
                </option>
              );
            })}
          </Field>
          {errors.licencaVeiculos && errors.licencaVeiculos[vehicleIndex]?.cdVeiculo ? (
            <FormHelperText>{errors.licencaVeiculos[vehicleIndex]?.cdVeiculo}</FormHelperText>
          ) : null}
        </FormControl>
      </Grid>
      {Object.keys(oldVehicle).length > 0 && (
        <>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="Município"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={oldVehicle.city}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="Nome / Razão Social"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={oldVehicle.name}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="CNPJ / CPF"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={oldVehicle.document}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              name=""
              label="Tipo de veículo"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={oldVehicle.type}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={2}>
            <TextField
              name=""
              label="Capacidade"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={oldVehicle.capacity}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
          <Grid item xs={12} sm={4}>
            <TextField
              name=""
              label="Categoria"
              margin="dense"
              variant="filled"
              fullWidth
              disabled
              value={oldVehicle.category}
              InputLabelProps={{
                shrink: true,
              }}
            />
          </Grid>
        </>
      )}

      <BaseComponent
        {...props}
        canEdit={canEdit}
        oldVehicle={oldVehicle}
        newVehicle={newVehicle}
        handleChangeNewVehicle={handleChangeNewVehicle}
        inspectedVehiclesFiltered={inspectedVehiclesFiltered}
        vehicleIndex={vehicleIndex}
      />
    </>
  );
};

export default withLicenseDuplicateVehicle;
